import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const ADD_LINKS_ID = 'add-links';

/**
 * A link to open a hidden block, drawn in the "Add to this tab" bar at the end of the tab, never between blocks.
 * The label names the thing ("Outreach list"); a leading "Add a" / "+" is dropped.
 */
export default function AddLink({ label, onClick }: { label: string; onClick: () => void }) {
  const [bottom, setBottom] = useState<HTMLElement | null>(null);
  useEffect(() => setBottom(document.getElementById(ADD_LINKS_ID)), []);
  const name = label.replace(/^\+\s*/, '').replace(/^add (an? |the )?/i, '');
  const link = (
    <button
      type="button"
      className="text-[15px] leading-[22px] text-accent underline underline-offset-[3px] hover:text-ink"
      onClick={onClick}
    >
      {name.charAt(0).toUpperCase() + name.slice(1)}
    </button>
  );
  return bottom ? createPortal(link, bottom) : null;
}

/** The slot AddLink portals into: shown only when it holds a link. */
export function AddBar() {
  return (
    <div className="mt-14 pt-4 border-t border-line flex flex-wrap items-baseline gap-x-6 gap-y-2 text-[15px] leading-[22px] [&:not(:has(#add-links>*))]:hidden">
      <span className="text-ink-3">Add to this tab:</span>
      <div id={ADD_LINKS_ID} className="contents" />
    </div>
  );
}
